import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTachometer, faUsers, faTasks, faEye, faPencil, faTrashCan, faVideo, faArrowLeft, faDumbbell, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useRecoilState } from 'recoil';

import { getSessionDetailAPI } from "../../../../API/Session";
import { putSessionUpdateAPI } from "../../../../API/Session";
import useLocalStorage from "../../../../Hooks/useLocalStorage";
import FormInputField from "../../../Reusable/FormInputField";
import PageLoadingContent from "../../../Reusable/PageLoadingContent";
import { topAlertMessageState, topAlertStatusState, userDetailState } from "../../../../AppState";
import UserSessionVideoSectionExerciseListDesktop from "./DetailForExerciseListDesktop";
import UserSessionVideoSectionExerciseListMobile from "./DetailForExerciseListMobile";


function UserSessionVideoSectionExerciseDetailForExercise() {
    ////
    //// URL parameters.
    ////

    const { uid, sid, vsid } = useParams()

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);
    const [user, setUser] = useRecoilState(userDetailState);

    ////
    //// Component states.
    ////

    const [setErrors] = useState({});
    const [session, setSession] = useLocalStorage(sid, "");
    const [selectedExerciseForDeletion, setSelectedExerciseForDeletion] = useState("");
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    function onSessionDetailSuccess(response){
        console.log("onSessionDetailSuccess: Starting...");
        setSession(response);
    }

    function onSessionDetailError(apiErr) {
        console.log("onSessionDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionDetailDone() {
        console.log("onSessionDetailDone: Starting...");
        setFetching(false);
    }

    function onExerciseDeleteSuccess(response){
        console.log("onExerciseDeleteSuccess: Starting..."); // For debugging purposes only.

        // Update notification.
        setTopAlertStatus("success");
        setTopAlertMessage("Exercise deleted");
        setTimeout(() => {
            console.log("onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Fetch again an updated list.
        getSessionDetailAPI(
            sid,
            onSessionDetailSuccess,
            onSessionDetailError,
            onSessionDetailDone
        );
    }

    function onExerciseDeleteError(apiErr) {
        console.log("onExerciseDeleteError: Starting..."); // For debugging purposes only.
        setErrors(apiErr);

        // Update notification.
        setTopAlertStatus("danger");
        setTopAlertMessage("Failed deleting");
        setTimeout(() => {
            console.log("onExerciseDeleteError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onExerciseDeleteDone() {
        console.log("onExerciseDeleteDone: Starting...");
        setFetching(false);
    }

    function onSessionUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Session updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);
    }

    function onSessionUpdateError(apiErr) {
        console.log("onSessionUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionUpdateError: Delayed for 2 seconds.");
            console.log("onSessionUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionUpdateDone() {
        console.log("onSessionUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onSelectExerciseForDeletion = (e, exercise) => {
        console.log("onSelectExerciseForDeletion", exercise);
        setSelectedExerciseForDeletion(exercise);
    }

    const onDeselectExerciseForDeletion = (e) => {
        console.log("onDeselectExerciseForDeletion");
        setSelectedExerciseForDeletion("");
    }

    const onDeleteConfirmButtonClick = (e) => {
        console.log("onDeleteConfirmButtonClick"); // For debugging purposes only.
        console.log("selectedExerciseForDeletion:", selectedExerciseForDeletion);

        //
        // The following code will remove the data from the JSON.
        //

        let eIndex;
        let videoSection = session.videoSections[vsid];
        for (let exerciseIndex in videoSection.exercises) {
            let ex = videoSection.exercises[exerciseIndex];
            if (ex.name === selectedExerciseForDeletion.name) {
                console.log(ex);
                eIndex = exerciseIndex;
                break;
            }
        }

        console.log("videoSectionIndex:", eIndex);
        videoSection.exercises.splice(eIndex, 1);

        // Remove from state.
        setSelectedExerciseForDeletion("");

        // Update the session.
        console.log("onSubmitClick, session:", session);
        putSessionUpdateAPI(session, onSessionUpdateSuccess, onSessionUpdateError, onSessionUpdateDone);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionDetailAPI(
                sid,
                onSessionDetailSuccess,
                onSessionDetailError,
                onSessionDetailDone
            );
        }

        return () => { mounted = false; }
    }, [sid]);

    ////
    //// Component rendering.
    ////

    // Defensive code: The following code will extract the video section from the session, else return null.
    let videoSection, name, detail, exercises = null;
    if (session !== undefined && session !== null && session !== "") {
        videoSection = session.videoSections[vsid];
        if (videoSection !== undefined && videoSection !== null && videoSection !== "") {
            name = videoSection.name;
            detail = videoSection.detail;
            exercises = videoSection.exercises;
        }
    }
    console.log(name, detail, exercises); // For debugging purposes only.

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/users" aria-current="page"><FontAwesomeIcon className="fas" icon={faUsers} />&nbsp;Users</Link></li>
                            <li class=""><Link to={`/user/${uid}/sessions`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Sessions)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-sections`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Video Sections)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercises</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-sections`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Video Sections</Link></li>
                        </ul>
                    </nav>

                    {/* Modals */}
                    <nav class="">
                        <div class={`modal ${selectedExerciseForDeletion ? 'is-active' : ''}`}>
                            <div class="modal-background"></div>
                            <div class="modal-card">
                                <header class="modal-card-head">
                                    <p class="modal-card-title">Are you sure?</p>
                                    <button class="delete" aria-label="close" onClick={onDeselectExerciseForDeletion}></button>
                                </header>
                                <section class="modal-card-body">
                                    You are about to delete this <b>exercise</b> and all the data inside of it. This action is cannot be undone. Are you sure you would like to continue?
                                </section>
                                <footer class="modal-card-foot">
                                    <button class="button is-success" onClick={onDeleteConfirmButtonClick}>Confirm</button>
                                    <button class="button" onClick={onDeselectExerciseForDeletion}>Cancel</button>
                                </footer>
                            </div>
                        </div>
                    </nav>

                    {/* Page */}
                    <nav class="box">
                        {/* Title + Options */}
                        <div class="columns">
                            <div class="column">
                                <p class="title is-4"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section - {user.firstName} {user.lastName}</p>
                            </div>
                            <div class="column has-text-right">
                                <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercises/add`} class="button is-small is-success is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faPlus} />&nbsp;New Exercise
                                </Link>
                            </div>
                        </div>

                        {/* Tabs */}
                        <div class="tabs is-medium">
                            <ul>
                                <li>
                                    <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}`} >Detail</Link>
                                </li>
                                <li>
                                    <Link class="is-active"><strong>Exercises</strong></Link>
                                </li>
                            </ul>
                        </div>

                        <p class="subtitle is-6"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercises</p>

                        {isFetching && <PageLoadingContent displayMessage={"Please wait"} />}

                        {!isFetching && <div class="container">
                            {/*
                                ##################################################################
                                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A DESKTOP SCREEN.
                                ##################################################################
                            */}
                            <div class="is-hidden-touch mb-5">
                                <UserSessionVideoSectionExerciseListDesktop
                                    uid={uid}
                                    sid={sid}
                                    vsid={vsid}
                                    exercises={exercises}
                                    onSelectExerciseForDeletion={onSelectExerciseForDeletion}
                                />
                            </div>

                            {/*
                                ###########################################################################
                                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A TABLET OR MOBILE SCREEN.
                                ###########################################################################
                            */}
                            <div class="is-fullwidth is-hidden-desktop mb-5">
                                <UserSessionVideoSectionExerciseListMobile
                                    uid={uid}
                                    sid={sid}
                                    vsid={vsid}
                                    exercises={exercises}
                                    onSelectExerciseForDeletion={onSelectExerciseForDeletion}
                                />
                            </div>

                        </div>}

                        <div class="columns">
                            <div class="column is-half">
                                <Link to={`/user/${uid}/session/${sid}/video-sections`} class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to User Video Sections</Link>
                            </div>
                            <div class="column is-half has-text-right">
                                <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercises/add`} class="button is-success is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faPlus} />&nbsp;Add Exercise</Link>
                            </div>
                        </div>
                    </nav>
                </section>
            </div>
        </>
    );
}

function ExerciseRow(props) {
    const { obj, uid, sid, vsid, eIndex, onSelectExerciseForDeletion } = props;
    if (obj === undefined) {
        return null;
    }
    const { name, duration, previewDescription, previewUrl, type, videoUrl } = obj;
    console.log(name, duration, previewDescription, previewUrl, type, videoUrl);
    return (
        <tr>
            <th>{name}</th>
            <td>{type}</td>
            <td>{duration}</td>
            <td class="is-pulled-right">
                <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eIndex}`} class="button is-small is-success jb-modal" data-target="sample-modal" type="button">
                    <FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View
                </Link>
                &nbsp;&nbsp;&nbsp;
                <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eIndex}/edit`} class="button is-small is-warning jb-modal" data-target="sample-modal" type="button">
                    <FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Edit
                </Link>
                &nbsp;&nbsp;&nbsp;
                <button onClick={(e, ses) => onSelectExerciseForDeletion(e, obj)} class="button is-small is-danger"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
            </td>
        </tr>
    );
}

export default UserSessionVideoSectionExerciseDetailForExercise;
